import { ClipboardCheck } from 'lucide-react';
import ChecklistBoard, { type ChecklistConfig } from './checklist/ChecklistBoard';
import { UAT_SECTIONS } from './checklist/uatSections';

/**
 * Platform-admin UAT (User Acceptance Testing) checklist for The Polished Version.
 * A thin configuration over the shared {@link ChecklistBoard}.
 */
const UAT_CONFIG: ChecklistConfig = {
  title: 'UAT Checklist',
  icon: ClipboardCheck,
  intro:
    'End-to-end user-acceptance checklist for The Polished Version. Work through each scenario, ' +
    'mark Pass or Fail, and record notes. Results are saved to the shared UAT record when online, ' +
    'with this browser kept as a fallback.',
  storageKey: 'tpv-uat-checklist-v1',
  recordNoun: 'UAT record',
  submissionsTitle: 'Saved UAT submissions',
  submissionsDescription: 'Platform admins can view browser checklist results saved by reviewers.',
  submissionsEmpty: 'No saved UAT submissions yet.',
  sections: UAT_SECTIONS,
};

const UATChecklist = () => <ChecklistBoard config={UAT_CONFIG} />;

export default UATChecklist;
